import { useState } from 'react'
import { fetchCsvFile, fetchSummaries } from '../service/locations'
import { downloadFile } from '../../common/helpers'

const useSummaries = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [exportLoading, setExportLoading] = useState(false)
  const [summaries, setSummaries] = useState([])
  const [errorPopupOpen, setErrorPopupOpen] = useState(false)

  const getSummaries = async (params) => {
    try {
      setLoading(true)
      const summariesResult = await fetchSummaries(params)
      setSummaries(summariesResult)
      setLoading(false)
    } catch (requestError) {
      setError(requestError)
    }
  }

  const exportToCsv = async (params) => {
    try {
      setExportLoading(true)
      const fetchFileResult = await fetchCsvFile(params)
      if (fetchFileResult && fetchFileResult.downloadUrl) {
        downloadFile(fetchFileResult.downloadUrl)
      } else {
        setError('CSV generation error.')
        setErrorPopupOpen(true)
      }
      setExportLoading(false)
    } catch (requestError) {
      setError(requestError)
      setErrorPopupOpen(true)
    }
  }

  return {
    error,
    loading,
    exportLoading,
    summaries,
    getSummaries,
    exportToCsv,
    errorPopupOpen,
    setErrorPopupOpen
  }
}

export default useSummaries
